<template>
<div id="ficheLte" class="modal_container">
  <div class="modal_background">
    <div class="modal">
      <div class="modal_header">
        <div class="pin pin_station_4G" :class="getCss4G()">4G</div>
        <h3>Détails station 4G/5G</h3>
        <span class="icon_close" @click="closeModal()"></span>
      </div>
      <div class="modal_content">
        <div class="resume">
          <div class="combo" v-if="listeLte.length > 1">
            <label>Emetteur :</label>
            <select v-model="selected">
              <option v-for="(item, index) in listeLte" :key="index">
                {{item.numeroStation}}
              </option>
            </select>
          </div>
          <div v-if="current">
            <div class="station_4G_text" :class="current.css4gtext">{{current.miseEnService}}</div>
            <div class="group">
              <label>Commune :</label>
              <p>{{current.commune | handleMissingValue}}</p>
            </div>
            <div class="group">
              <label>Technologie :</label>
              <p>{{current.technoLte | handleMissingValue}}</p>
            </div>
            <div class="group">
              <label>Opérateur :</label>
              <p>{{current.operateur | handleMissingValue}}</p>
            </div>
            <div class="group">
              <label>Fréquence centrale :</label>
              <p>{{current.frequence +" MHz" | handleMissingValue}}</p>
            </div>
            <div class="group">
              <label>Azimuts :</label>
              <p>{{current.azimut | handleMissingValue}}</p>
            </div>
            <div class="group">
              <label>Date de mise en service :</label>
              <p>{{current.dateDebut | printDate | handleMissingValue}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal_footer">
        <button @click="closeModal()" class="button dark">Fermer</button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'FicheLte',
  components: {},
  data() {
    return {
      listeLte: [],
      selected: null
    }
  },
  computed: {
    current() {
      if (this.selected) {
        return this.listeLte.filter(item => item.numeroStation == this.selected)[0];
      } else if (this.listeLte.length == 1) {
        return this.listeLte[0];
      }
      return null;
    }
  },
  filters: {
    printDate(value) {
      return (value != null) ? moment(new Date(value)).format('DD/MM/YYYY') : null;
    },
    handleMissingValue(value) {
      return (value != null && value.toString().length > 0) ? value : "Non renseigné";
    }
  },
  created() {},
  destroyed() {},
  methods: {
    loadLte(lte) {
      var emetteur = lte.values_ || lte.properties;
      if (emetteur.dateDebut && emetteur.dateDebut != null && emetteur.dateDebut != "") {
        var date = new Date(emetteur.dateDebut);
        var weekago = new Date();
        weekago.setDate(weekago.getDate() - 7);
        //calcul de css en fonction de la date de service
        if (date > weekago) {
          emetteur.css4g = "station_4G_recent"
          emetteur.css4gtext = "station_4G_text_recent"
          emetteur.miseEnService = "Mise en service il y a moins d'une semaine"
        } else {
          emetteur.css4g = ""
          emetteur.css4gtext = ""
          emetteur.miseEnService = "Mise en service il y a une semaine ou plus"
        }
      } else {
        emetteur.css4g = "station_4G_out"
        emetteur.css4gtext = "station_4G_text_out"
        emetteur.miseEnService = "Cette station n'a pas de date de mise en service"
      }
      this.listeLte.push(emetteur);
      if (this.listeLte.length == 1) {
        this.selected = emetteur.numeroStation;
      }
      this.openModal()
    },
    getCss4G() {
      return (this.current) ? this.current.css4g : 'station_4G_out';
    },
    openModal() {
      var modal = document.getElementById('ficheLte');
      var body = document.getElementsByTagName('body')[0];
      modal.classList.add('animation');
      body.classList.add('modal_active');
    },
    closeModal() {
      var modal = document.getElementById('ficheLte');
      var body = document.getElementsByTagName('body')[0];
      modal.classList.remove('animation');
      body.classList.remove('modal_active');
      this.listeLte = [];
      this.selected = null;
    }
  }
}
</script>

<style>
.modal {
  min-width: 45%;
  padding: 5px;
  max-height: 80vh;
  overflow-y: scroll;
}

.combo {
  font-size: 16px;
  color: #007ABC;
  font-weight: bold;
  margin-bottom: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid rgb(220, 220, 220);
}

.combo label {
  margin-right: 20px;
}
</style>
